import { connect } from 'react-redux';
import withPGTranslation from '../../config/withPGTranslation';
import AdvisorAvatar from './advisor_avatar';
import { authPendingAction, displayRegister } from '../../actions/auth';

export const advisorThemes = {
  staff_pick: 'staff_pick',
  personal: 'personal',
  badge: 'badge',
  badge_end_to_end: 'badge_end_to_end',
  searchResult: 'searchResult',
  someOtherAdvisor: 'someOtherAdvisor',
  profileSmallAvatar: 'profileSmallAvatar',
  sticky_icons: 'sticky_icons',
  homePageAllAdvisors: 'homePageAllAdvisors',
  recommendedCarousel: 'recommendedCarousel',
  advisors_from_country: 'advisors_from_country'
};

export const advisorThemesDesktopSize = {
  staff_pick: [250, 250],
  personal: [80, 80],
  badge: [250, 250],
  badge_end_to_end: [150, 150],
  searchResult: [250, 250],
  someOtherAdvisor: [250, 250],
  profileSmallAvatar: [50, 50],
  sticky_icons: [50, 50],
  homePageAllAdvisors: [250, 250],
  recommendedCarousel: [120, 120],
  advisors_from_country: [250, 250]
};

const mapStateToProps = () => ({
});

export default connect(mapStateToProps, {
  authPendingAction,
  displayRegister
})(withPGTranslation(AdvisorAvatar));
